import { Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import API from "../services/api-request";

const SelectPallet = ({
  value,
  onChange,
  allowUsed = true,
  usedOnly = false,
}) => {
  const [listData, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPallet = async () => {
    setLoading(true);
    try {
      const res = await API.Get(
        `pallet?${
          usedOnly
            ? "weightGreaterThanZero=true"
            : allowUsed
            ? ""
            : "emptyOrZeroWeightStock=true"
        }`
      );
      setData(res?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPallet();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={listData.length < 1 ? "No Data" : value || null}
      optionFilterProp="label"
      placeholder="Pilih Pallet"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.name,
        value: e.id,
        type: e.type,
      }))}
    />
  );
};

export default SelectPallet;
